export const reloadGoogleMap = (mapUrl: string) => {
	const mapsUrl = mapUrl;
	const existingScript = Array.from(
		document.getElementsByTagName('body')[0].getElementsByTagName('script')
	).find((script) =>
		script.src.includes(
			'https://maps.googleapis.com/maps/api/js?key=AIzaSyAjtlB7VsJ0SmtNzMGXyw0_EmSXQvd6qBk&libraries=places'
		)
	);
	existingScript?.remove();
	const siteBody = document.getElementsByTagName('body')[0];
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = mapsUrl;
	script.defer = true;
	siteBody?.appendChild(script);
};
